import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../utils";

// Base route constant
const baseRoute = `/achievement-management`;

// * Route configuration object for achievementManagement-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const achievementManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:achievementId`,
  edit: `${baseRoute}/edit/:achievementId`,
} as const;

// ! these are breadcrumbs translation not page title
const achievementManagementRouteTranslation: IRouteTranslation<
  typeof achievementManagementRoutesObj
> = {
  list: "achievementManagement",
  create: "addAchievement",
  edit: "editAchievement",
  view: "viewAchievement",
};

// * Extracts the route parameters for the achievementManagement route configuration.
export type IAchievementManagementRouteParams = IExtractRouteParamMap<
  typeof achievementManagementRoutesObj
>;

// * Path functions for the achievementManagement routes.
export const achievementManagementPath = createPaths<
  typeof achievementManagementRoutesObj,
  IAchievementManagementRouteParams
>(achievementManagementRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const achievementBreadcrumbs = createBreadcrumbObject<
  typeof achievementManagementRoutesObj
>(achievementManagementRoutesObj, achievementManagementRouteTranslation);
rebase(achievementBreadcrumbs, "list");
